import { render, staticRenderFns } from "./SidebarTabExternalSectionLegacy.vue?vue&type=template&id=7c3e42b5&scoped=true"
import script from "./SidebarTabExternalSectionLegacy.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarTabExternalSectionLegacy.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SidebarTabExternalSectionLegacy.vue?vue&type=style&index=0&id=7c3e42b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e42b5",
  null
  
)

export default component.exports